/**
 * Map of supported render types
 * These correspond to the supported formats outlined in formats.go, and should
 * be kept in sync with those.
 * Certain formats when rendered, for example, the geojson code in this repo
 * handles both geojson and topojson files.
 */
const RENDER_FORMATS = {
  solid: 'solid',
  geojson: 'geojson',
  image: 'img',
  pdf: 'pdf',
  psd: 'psd',
  mermaid: 'mermaid'
}

/**
 * Map of supported states for the Status class
 * Enumerates the status message types accepted by the rails app
 */
const STATUS_TYPES = {
  constructor: 'constructor',
  hello: 'hello',
  resize: 'resize',
  loading: 'loading',
  loaded: 'loaded',
  error: 'error',
  fatal: 'error:fatal',
  ready: 'ready',
  // this needs to match the string in github/github/app/assets/modules/github/behaviors/render-editor.ts
  markdown: 'code_rendering_service:markdown:get_data'
}

/**
 * This is set within the github css. However, because we need to manually
 * update the render container's height during pjax nav events, we also need to ensure that
 * every renderable type fires a resize event some height; this is a fallback for types
 * that did not previously report their height. For now, those types are `geojson` and `stl`
 */
const DEFAULT_CONTAINER_HEIGHT = 500

export {RENDER_FORMATS, STATUS_TYPES, DEFAULT_CONTAINER_HEIGHT}
